<template>
  <el-dropdown trigger="click" :disabled="disabled">
    <span class="el-dropdown-link">
      <slot name="prefix"></slot>
      {{ convertArrayToMap(data)[value] }}
      <slot name="suffix"></slot>
    </span>
    <template #dropdown>
      <el-dropdown-menu :style="'width:' + dropdownWidth + 'px'">
        <div v-for="item in data" :key="item.value">
          <el-dropdown-item
            :class="{ active: currentValue == item.value }"
            :disabled="item.disabled"
            @click="handleChange(item.value)"
            v-if="!item.hide"
          >
            <img :src="item.icon" v-if="item.icon" />
            {{ item.label }}
            <!-- <i
            class="iconfont icon-duigouxiao"
            style="font-size: 10px"
            v-if="currentValue == item.value"
          /> -->
          </el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import {
  ref,
  reactive,
  defineEmits,
  watch,
  defineProps,
  defineExpose,
  onMounted,
  computed,
} from "vue";
import { convertArrayToMap } from "@/utils/convertArrayToMap.js";

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  value: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  dropdownWidth: { type: String, default: "150" },
});

const emits = defineEmits(["change", "update:value"]);

const currentValue = ref("");
watch(
  () => props.value,
  (newVal) => {
    currentValue.value = newVal;
  },
  {
    immediate: true,
  }
);

const handleChange = (value) => {
  emits("update:value", value);
  emits("change", value);
};
</script>

<style lang="scss" scoped>
:deep(.el-dropdown-menu__item) {
  justify-content: flex-start;
  img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
}
</style>
